import React from 'react';
import classnames from 'classnames';

import './WpContainerFooter.scss';

export interface Props {
  /** The content to display inside the container. */
  children?: React.ReactNode;
  backgroundColor?: string;
  justifyContent?: 'flexStart' | 'flexEnd' | 'spaceBetween' | 'center';
}

const WpContainerFooter: React.FC<Props> = ({ children, justifyContent = 'flexStart', backgroundColor }: Props) => {
  const classNamePrefix = 'WpContainerFooter';
  const classes = classnames(classNamePrefix, `${classNamePrefix}--${justifyContent}`);
  return (
    <div className={classes} style={{ backgroundColor }}>
      {children}
    </div>
  );
};

export default WpContainerFooter;
